import { get, isEmpty } from 'lodash';
import { useRootStore } from '@nandosaus/state-management';

const useBrazeUpsellContent = ({ heading, cta }) => {
  const { BrazeStore, MenuStore } = useRootStore();
  const { upsellCard } = BrazeStore;
  if (!upsellCard || isEmpty(upsellCard.products)) {
    const { menu } = MenuStore;
    const menuRecommendedProducts = get(menu, 'recommendedProducts', []);

    return {
      upsellNewProductIds: [],
      upsellRecommendedProducts: menuRecommendedProducts,
      upsellHeading: heading,
      upsellCta: cta,
    };
  }
  return {
    upsellNewProductIds: get(upsellCard, 'new-products', null) ? get(upsellCard, 'new-products').split(',') : null,
    upsellRecommendedProducts: upsellCard.products,
    upsellHeading: get(upsellCard, 'heading', null),
    upsellCta: get(upsellCard, 'cta', null),
  };
};

export { useBrazeUpsellContent };
